// extracted by mini-css-extract-plugin
export var actionText = "_oe-4";
export var container = "_oe-0";
export var leftSection = "_oe-1";
export var rightSection = "_oe-2";
export var settingsButton = "_oe-6";
export var settingsIcon = "_oe-7";
export var shortcut = "_oe-5";
export var shortcutGroup = "_oe-3";